type AppEnv = 'development' | 'dev' | 'stage' | 'production';

interface AppConfig {
  title: string;
  iconPath: string;
  logoPath: string;
  titleColor: string;
  env: AppEnv;
}

const BASE_TITLE = 'Myena HR Management System';

const env = (process.env.REACT_APP_ENV || 'development') as AppEnv;

const configs: Record<AppEnv, AppConfig> = {
  production: {
    title: BASE_TITLE,
    iconPath: '/icons/myena-icon.svg',
    logoPath: '/icons/myena-icon-text-side.svg',
    titleColor: '#bf4e00',
    env: 'production',
  },
  stage: {
    title: `${BASE_TITLE} - STAGE`,
    iconPath: '/icons/myena-icon.svg',
    logoPath: '/icons/myena-icon-text-side.svg',
    titleColor: '#00695c',
    env: 'stage',
  },
  dev: {
    title: `${BASE_TITLE} - DEV`,
    iconPath: '/icons/myena-icon.svg',
    logoPath: '/icons/myena-icon-text-side.svg',
    titleColor: '#0d47a1',
    env: 'dev',
  },
  development: {
    title: `${BASE_TITLE} - DEV`,
    iconPath: '/icons/myena-icon.svg',
    logoPath: '/icons/myena-icon-text-side.svg',
    titleColor: '#0d47a1',
    env: 'development',
  },
};

export const appConfig: AppConfig = configs[env] ?? configs.development;
